// Use this file for site specific scripts
// Index
document.addEventListener("DOMContentLoaded", function () {
	const spotlights = [
		{
			image: "/_files/images/content/index/spotlight/jessica-le-2x.png",
			alt: "Jessica Le",
			quote: "“At UTSA, I met amazing faculty members who helped me fuel my passion in technology.”",
			name: "Jessica Le '18",
			program: "Information Systems and Cyber Security",
			link: "#",
		},
		{
			image: "/_files/images/content/index/spotlight/placeholder-spotlight-2x.png",
			alt: "Mario Garcia",
			quote: "“The hands-on experience at UTSA gave me the confidence to start my own business.”",
			name: "Mario Garcia '20",
			program: "Entrepreneurship",
			link: "#",
		},
		{
			image: "/_files/images/content/index/spotlight/placeholder-spotlight-1-2x.png",
			alt: "Sophia Kim",
			quote: "“UTSA challenged me to grow as both a student and a leader.”",
			name: "Sophia Kim '22",
			program: "Mechanical Engineering",
			link: "#",
		},
	];

	const random = spotlights[Math.floor(Math.random() * spotlights.length)];

	// Update image
	const imgEl = document.getElementById("spotlight-img");
	imgEl.src = random.image;
	imgEl.alt = random.alt;

	// Update quote
	document.getElementById("spotlight-quote").textContent = random.quote;

	// Update cite with name and program
	document.getElementById("spotlight-cite").innerHTML = `<a href="${random.link}"><strong>${random.name}</strong></a><br><em>${random.program}</em>`;
});
